<template>
  <div @click="close" class="login-container">
    <div @click.stop="" class="login" :style="{
      backgroundImage: type ? 'url(' + ph_image + ')' : 'url(' + pic_image + ')',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
    }">
      <i class="close" @click="close"></i>
      <div class="box">
        <div class="tab">
          <div class="tab-item" v-for="(item, index) in tabList" :key="index" :class="tabActive == index ? 'tab-item-active' : ''" @click="tabChange(index)">
            {{ item }}
          </div>
        </div>
        <!-- 手机号登录 -->
        <div v-if="tabActive == 0" class="login-box">
          <div>
            <input @blur="fixBlur" v-model="phoneData.mobile" type="text" placeholder="请输入手机号" />
          </div>
          <div class="show-password">
            <input @blur="fixBlur" minlength="4" maxlength="4" v-model="phoneData.code" type="text" placeholder="请输入短信验证码" />
            <strong v-show="canClick" @click="getVerificationCode">获取验证码</strong>
            <strong v-show="!canClick">{{ content }}</strong>
          </div>
        </div>
        <!-- 账号密码登录 -->
        <div v-else class="login-box">
          <div>
            <input @blur="fixBlur" v-model="cipherData.mobile" type="text" placeholder="请输入账号" />
          </div>
          <div class="show-password">
            <input ref="inputRef" @blur="fixBlur" minlength="6" maxlength="10" v-model="cipherData.password" :type="inputType" placeholder="请输入密码" />
            <i @click="inputTypeChange"></i>
          </div>
        </div>
        <!-- 勾选 -->
        <div class="checkbox-box">
          <!-- <div class="checkbox-list" style="text-align: left">
          <input class="checkbox" v-model="checked1" type="checkbox" @change="checkedChange(checked1, 1)" name="1" id="1" />
          <span>保持7天登录</span>
        </div> -->
          <div class="checkbox-list" style="text-align: left">
            <input class="checkbox" v-model="checked2" @change="checkedChange(checked2, 1)" type="checkbox" name="1" id="1" />
            <!-- <el-checkbox v-model="checked2"></el-checkbox> -->
            <span>我已详细阅读并同意
              <strong @click="getAgree('服务协议')">《服务协议》</strong> 和
              <strong @click="getAgree('隐私政策')">《隐私政策》</strong>
            </span>
          </div>
        </div>
        <div class="agree-box" v-show="agree.show">
          <div class="agree-title">{{ agree.title }}</div>
          <div class="agree-contenet" v-html="agree.text"></div>
          <div class="agree-read" @click="agree.show = false">我已阅读</div>
        </div>
        <div class="sign" @click="submit">登 录</div>
        <el-dialog title="设置初始密码" width="30%" top="38vh" :visible.sync="dialogVisible" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false">
          <div class="dialog-item">
            <span>请设置密码：</span>
            <input v-model="password1" id="dialog-input" class="dialog-input" maxlength="10" type="password" placeholder="" password />
          </div>

          <div slot="footer" class="dialog-footer">
            <el-button size="mini" class="dialog-btn" type="primary" @click="dialogOk">确 定</el-button>
          </div>
          <!-- <button class="dialog-btn">确认</button> -->
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserinfo } from "@/api/person.js";
import { isPhone, isNumber, isPCMobile } from "../utils/tools";
import { set, get } from "../utils/tools";

import { mapState } from "vuex";
export default {
  props: {
    type: {
      type: [String, Number],
      default: "",
    }
  },
  data () {
    return {
      pic_image: "",
      ph_image: "",
      password1: "",
      dialogVisible: false,
      tabList: ["短信登录/注册", "密码登录"],
      phoneData: {
        //手机登录
        mobile: "",
        code: "",
        auto: 0,
      },
      cipherData: {
        //密码登录
        mobile: "",
        password: "",
        auto: 0,
      },
      tabActive: 0,
      checked1: false, //7天免登录
      checked2: false, //阅读服务协议
      inputType: "password", //显示影藏密码
      canClick: true, //倒计时
      refreshData: null, //清除倒计时
      content: "", //读秒
      agree: {
        //协议弹窗
        show: false,
        text: "",
        title: "",
      },
    };
  },
  computed: {
    ...mapState(["loginShow"])
  },
  watch: {
    loginShow: {
      handler (val) {
        if (val) {
          this.$nextTick(() => {
            const bodyStyle = document.body.style; // 获取body样式
            bodyStyle.overflow = "hidden"; // 设置溢出内容为隐藏
            const htmlStyle = document.getElementsByTagName("html")[0].style; // 获取html样式
            htmlStyle.overflow = "hidden"; // 设置溢出内容为隐藏
          });
        }
      },
      deep: true,
      immediate: true,
    }
  },
  methods: {
    checkedChange (e, i) {
      // console.log(e,i,"checkedChange");
    },
    // 关闭
    close () {
      this.$store.commit("setLoginShow", 0);
      this.$nextTick(() => {
        const bodyStyle = document.body.style; // 获取body样式
        bodyStyle.overflow = "inherit"; // 设置溢出内容为隐藏
        const htmlStyle = document.getElementsByTagName("html")[0].style; // 获取html样式
        htmlStyle.overflow = "inherit"; // 设置溢出内容为隐藏
      });
    },
    // 倒计时
    countdowm () {
      let totalTime = 120;
      if (!this.canClick) return; //节流
      this.canClick = false;
      this.content = totalTime + "s";
      this.refreshData = window.setInterval(() => {
        totalTime--;
        this.content = totalTime + "s";
        if (totalTime < 0) {
          //当倒计时小于0时清除定时器
          window.clearInterval(this.refreshData); //清除定时器
          this.content = "重新开始倒计时";
          totalTime = 120;
          this.canClick = true; //这里重新开启
        }
      }, 1000);
    },

    tabChange (i) {
      this.tabActive = i;
    },
    // 协议
    getAgree (e) {
      let _this = this;
      _this.agree.title = e;
      _this.agree.show = true;
      let param = {
        substation_id: set(_this.config.substationId),
        name: e,
      };
      _this.$userPost("/getNews_detail", param).then((res) => {
        // console.log(res,"获取协议");
        _this.agree.text = res.s_content;
      });
    },

    // 显示影藏密码
    inputTypeChange () {
      if (this.inputType == "text") {
        this.inputType = "password";
      } else {
        this.inputType = "text";
      }

      this.$nextTick(() => {
        this.$refs.inputRef.focus();
      })
    },

    // 验证码
    getVerificationCode () {
      if (!isPhone(this.phoneData.mobile)) {
        return this.$message({
          message: "请输入正确手机号",
          type: "warning",
        });
      }
      let param = {
        mobile: this.phoneData.mobile,
      };
      this.$userPost("/sendSmsCode", param)
        .then((res) => {
          // console.log(res,"验证码");

          if (res.code == 0) {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          } else {
            this.$message({
              message: "验证码已成功发送",
              type: "success",
            });
            this.countdowm();
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    // 登录
    submit () {
      if (this.checked1) {
        this.cipherData.auto = 1;
        this.phoneData.auto = 1;
      }

      // 判断手机登录还是账号密码登录
      if (this.tabActive == 0) {
        if (!this.phoneData.mobile) {
          return this.$message.error("请输入手机号");
        }
        if (!isPhone(this.phoneData.mobile)) {
          return this.$message.error("手机号输入错误");
        }
        if (!this.phoneData.code) {
          return this.$message.error("请输入短信验证码");
        }
        if (!isNumber(this.phoneData.code)) {
          return this.$message.error("短信验证码输入错误");
        }
        if (!this.checked2) {
          return this.$message.error(
            "请勾选我已详细阅读 《服务协议》 和 《隐私协议》"
          );
        }
        this.phoneSignIn();
      } else {
        if (!this.cipherData.mobile) {
          return this.$message.error("请输入账号");
        }
        // if(!isPhone(this.cipherData.mobile)){
        //     return this.$message.error("手机号输入错误");
        // }
        if (!this.cipherData.password) {
          return this.$message.error("请输入密码");
        }
        if (
          this.cipherData.password.length < 6 ||
          this.cipherData.password.length > 10
        ) {
          this.$message.warning("请输入6-10位密码");
        }
        if (!this.checked2) {
          return this.$message.error(
            "请勾选我已详细阅读 《服务协议》 和 《隐私协议》"
          );
        }
        this.passwordSignIn();
      }
    },
    // 手机登录
    phoneSignIn () {
      this.$userPost("/phoneLogin", this.phoneData).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: res.msg,
            type: "warning",
          });
        } else {
          this.$message({
            message: "恭喜您登录成功",
            type: "success",
          });
          // if (this.checked1) {
          //   let time = new Date().getTime() + 604800000;
          //   this.$store.commit("setTime", time);
          // } else {
          //   let day = 1000 * 60 * 60 * 24 * 1;
          //   let time = new Date().getTime() + day;
          //   this.$store.commit("setTime", time);
          // }
          if (res.userinfo.is_password == 0) {
            // console.log("sdf");
            this.dialogVisible = true;
          }

          this.$store.dispatch("addMenuRoutes", {
            id: 99,
            name: "个人中心",
            url: "/personCenter",
            type: "2",
            weigh: 4,
            createtime: "2022-10-20 16:59",
            hid: 0,
          });
          this.$store.commit("setRead", 1);
          this.$store.commit("setLogin", 0);
          this.$store.commit("setLoginShow", 0);
          this.$store.commit("setUserInfo", res.userinfo);
          this.$store.commit("setToken", res.userinfo.token);
          // 清除之前填报的内容
          this.phoneData.mobile = "";
          this.phoneData.code = "";
          this.cipherData.mobile = "";
          this.cipherData.password = "";
          this.close();
        }
      });
    },
    // 账号密码登录
    passwordSignIn () {
      // console.log(this.cipherData,"登录时输入的密码");
      this.$userPost("/passwordLogin", this.cipherData).then((res) => {
        // console.log(res,"账号密码登录");
        if (res.code == 0) {
          this.$message({
            message: res.msg,
            type: "warning",
          });
        } else {
          this.$message({
            message: "恭喜您登录成功",
            type: "success",
          });
          // if (this.checked1) {
          //   let time = new Date().getTime() + 604800000;
          //   this.$store.commit("setTime", time);
          // } else {
          //   let day = 1000 * 60 * 60 * 24 * 1;
          //   let time = new Date().getTime() + day;
          //   this.$store.commit("setTime", time);
          // }
          this.$store.commit("addMenuRoutes", {
            id: 99,
            name: "个人中心",
            url: "/personCenter",
            type: "2",
            weigh: 4,
            createtime: "2022-10-20 16:59",
            hid: 0,
          });
          this.$store.commit("setRead", 1);
          this.$store.commit("setLogin", 0);
          this.$store.commit("setLoginShow", 0);
          this.$store.commit("setUserInfo", res.userinfo);
          this.$store.commit("setToken", res.userinfo.token);
          this.close();
        }
      });
    },
    getUserInfo () {
      // 查询最新个人资料
      getUserinfo().then((res) => {
        this.$store.commit("setUserInfo", res.userinfo);
        this.$store.commit("setToken", res.userinfo.token);
      });
    },

    dialogOk () {
      if (this.password1.length < 6 || this.password1.length > 10) {
        return this.$message.error("请输入6-10位密码");
      }
      // console.log(this.password1,"设置的密码");
      let param = {
        token: this.$store.state.token,
        password: this.password1,
      };
      this.$userPost("/editUserLoginPassword", param).then((res) => {
        this.$message.success("密码设置成功！");
        this.getUserInfo();
        this.dialogVisible = false;
      });
    },
    getLoginBanner () {
      this.$userPost("/getLoginBanner", this.phoneData).then((res) => {
        // console.log(res, "res");
        this.pic_image = res.pic_image;
        this.ph_image = res.ph_image;
      });
    },

    // 失去焦点事件
    fixBlur () {
      if (isPCMobile()) {
        document.body.scrollTop = 0;
        document.body.scrollIntoView();
      }
    }
  },
  created () {
    this.getLoginBanner();
  },
  mounted () {
    this.$nextTick(() => {
      let read = JSON.parse(JSON.stringify(localStorage.getItem("read")));
      // console.log(read,"read");
      if (read == 0) {
        this.checked2 = false;
      } else {
        this.checked2 = true;
      }
    });
  },
  beforeDestroy () {
    // 销毁倒计时
    if (this.refreshData) {
      // console.log('销毁倒计时')
      clearInterval(this.refreshData);
      this.refreshData = null;
    }
    this.$nextTick(() => {
      const bodyStyle = document.body.style; // 获取body样式
      bodyStyle.overflow = "inherit"; // 设置溢出内容为隐藏
      const htmlStyle = document.getElementsByTagName("html")[0].style; // 获取html样式
      htmlStyle.overflow = "inherit"; // 设置溢出内容为隐藏
    });
  },
};
</script>

<style lang="scss" scoped>
// ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
// ::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner{
//   background-color: #13c213;
//   border-color: #13c213;
// }
// ::v-deep .el-checkbox__inner:hover {
//     border-color: #13c213;
// }
// ::v-deep .el-checkbox{
//   color: #999999;
// }
// ::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
//     color: #13c213;
// }

.login-container {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba($color: #000, $alpha: .5);
  z-index: 1000;
}

.login {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 0px 20px 0px 20px;
  z-index: 1001;

  .close {
    right: 12px;
    top: 12px;
    width: 18px;
    height: 18px;
    cursor: pointer;
    position: absolute;
    background: url("../assets/img/close.png") no-repeat;
    background-size: 100% 100%;
  }

  .box {
    position: absolute;
    top: 38px;
    right: 40px;
    padding: 20px 30px 30px;
    border-radius: 0px 10px 0px 10px;
    background: rgba(255, 255, 255, 0.15);
    box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.25),
      0px 4px 35px 0px rgba(0, 0, 0, 0.08);
    box-sizing: border-box;

    .tab {
      color: #ffffff;
      display: flex;
      box-sizing: border-box;
      position: relative;
      font-size: 16px;

      .tab-item {
        width: 50%;
        padding: 10px;
        text-align: center;
        cursor: pointer;
      }

      .tab-item-active {
        border-bottom: 1px solid #fff;
      }
    }

    .login-box {
      box-sizing: border-box;
      text-align: center;
      margin: 0 auto;
      padding-top: 30px;
      padding-bottom: 10px;

      div {
        margin-bottom: 6px;

        input {
          box-sizing: border-box;
          width: 100%;
          height: 40px;
          padding: 0 15px;
          font-size: 14px;
          line-height: 14px;
          background-color: transparent;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          color: #fff;
          border-bottom: 1px solid rgba(255, 255, 255, 0.24);

          @media screen and (min-width: 310px) and (max-width: 900px) {
            height: 55px;
            font-size: 16px;

            &::placeholder {
              color: rgba($color: #fff, $alpha: .8);
            }
          }
        }
      }

      .show-password {
        position: relative;

        i {
          display: inline-block;
          position: absolute;
          cursor: pointer;
          top: 50%;
          width: 24px;
          height: 24px;
          right: 10px;
          transform: translateY(-50%);
          background: url("../assets/img/mima.png") no-repeat;
          background-size: 100% 100%;
        }

        strong {
          position: absolute;
          cursor: pointer;
          top: 50%;
          transform: translateY(-50%);
          font-family: Source Han Sans CN, Source Han Sans CN-Medium;
          font-weight: 500;
          color: #ffffff;
          right: 10px;
          font-size: 14px;

          @media screen and (min-width: 310px) and (max-width: 900px) {
            font-size: 16px;
          }
        }
      }
    }
  }

  .checkbox-box {
    .checkbox-list {
      margin-top: 18px;
      width: 100%;
      margin: 20px 0;
      display: flex;
      box-sizing: border-box;
      text-align: left;

      span {
        margin-left: 10px;
        font-size: 12px;
        line-height: 15px;
        font-family: Source Han Sans CN, Source Han Sans CN-Regular;
        font-weight: 400;
        color: #999999;

        @media screen and (min-width: 310px) and (max-width: 900px) {
          color: rgba($color: #fff, $alpha: .8);
        }

        strong {
          cursor: pointer;

          &:hover {
            color: #e2992b;
          }
        }
      }
    }

    .checkbox {
      width: 12px;
      height: 12px;
      position: relative;
      background-color: #fff;
    }

    .checkbox:after {
      position: absolute;
      top: 0;
      left: 0;
      content: "";
      width: 12px;
      height: 12px;
      line-height: 12px;
      background-color: #fff;
      color: #000000;
      display: inline-block;
      visibility: visible;
      border-radius: 3px;
      border: 1px solid #fff;
    }

    .checkbox:checked:after {
      content: "✓";
      font-size: 12px;
      text-align: center;
      color: #fff;
      background-color: #13c213;
      border: 1px solid #13c213;
    }
  }

  .agree-box {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
    border-radius: 10px;
    box-sizing: border-box;
    box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.25);
    background: #e7e7e7;

    .agree-title {
      text-align: center;
      font-size: 16px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 500;
      color: #1f1f23;
    }

    .agree-contenet {
      margin: 30px 0;
      padding: 20px;

      box-sizing: border-box;
      background-color: #fff;
      border-radius: 4px;
      font-size: 14px;
      color: #000;
      overflow-y: auto;
    }

    .agree-read {
      cursor: pointer;
      width: 200px;
      height: 44px;
      line-height: 44px;
      border-radius: 22px;
      text-align: center;
      margin: 0 auto;
      background: #252838;
      color: #fff;
      font-size: 14px;
      font-family: Source Han Sans CN, Source Han Sans CN-Regular;
      font-weight: 400;
    }
  }
}

.sign {
  width: 100%;
  margin-bottom: 20px;
  text-align: center;
  background: #ffffff;
  border-radius: 30px;
  padding: 10px 0;
  font-size: 16px;
  font-family: Source Han Sans CN, Source Han Sans CN-Regular;
  font-weight: 500;
  color: #1f1f23;
  cursor: pointer;

  &:hover {
    background-color: rgba(125, 185, 133, 0.8);
    color: #fff;
  }
}

::v-deep .el-dialog__body {
  padding-top: 12px;
  padding-bottom: 12px;
}

.dialog-item {
  margin-bottom: 12px;

  span {
    font-size: 16px;
    margin-right: 10px;
  }

  #dialog-input {
    border: 1px solid #999;
    border-radius: 4px;
    padding: 5px 12px;
  }
}

.dialog-btn {
  border: 1px solid #00b386;
  color: #fff;
  background-color: #00b386;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    border: 1px solid #00b386;
    background-color: #00b386;
    opacity: 0.8;
  }
}

@media only screen and (min-width: 901px) {
  .login {
    width: 800px;
    height: 470px;

    .box {
      width: 334px;
      height: 393px;
    }

    .agree-box {
      width: 1240px;
      height: 800px;
      padding: 40px;

      .agree-contenet {
        height: 85%;
      }
    }
  }
}

@media screen and (min-width: 310px) and (max-width: 900px) {
  .login {
    width: 92%;
    height: 470px;

    .box {
      width: 364px;
      height: 393px;
    }

    .agree-box {
      width: 92%;
      height: 600px;
      padding: 40px;

      .agree-contenet {
        height: 75%;
      }
    }
  }

  ::v-deep .el-dialog {
    width: 80% !important;
  }
}
</style>
